const STATUS_OPTIONS = [
  { value: "NEW", label: "NEW" },
  { value: "CONTACTED", label: "CONTACTED" },
  { value: "FOLLOW_UP", label: "FOLLOW_UP" },
  { value: "PROPOSAL_SENT", label: "PROPOSAL_SENT" },
  { value: "NEGOTIATION", label: "NEGOTIATION" },
  { value: "CLOSED_WON", label: "CLOSED_WON" },
  { value: "CLOSED_LOST", label: "CLOSED_LOST" },
];

const SOURCE_OPTIONS = [
  { value: "WEBSITE", label: "WEBSITE" },
  { value: "INSTAGRAM", label: "INSTAGRAM" },
  { value: "GOOGLE_ADS", label: "GOOGLE_ADS" },
  { value: "REFERRAL", label: "REFERRAL" },
  { value: "WALK_IN", label: "WALK_IN" },
  { value: "B2B_REFERRAL", label: "B2B_REFERRAL" },
  { value: "WHATSAPP", label: "WHATSAPP" },
  { value: "EMAIL", label: "EMAIL" },
  { value: "CALL", label: "CALL" },
  { value: "TRADE_FAIR", label: "TRADE_FAIR" },
  { value: "OTHER", label: "OTHER" },
];

const FOLLOWUP_TYPE_OPTIONS = [
  { value: "OUTBOUND_CALL", label: "OUTBOUND_CALL" },
  { value: "WHATSAPP", label: "WHATSAPP" },
  { value: "EMAIL", label: "EMAIL" },
  { value: "PAYMENT_COLLECTION", label: "PAYMENT_COLLECTION" },
  { value: "DOCUMENT_COLLECTION", label: "DOCUMENT_COLLECTION" },
  { value: "IN_PERSON_MEETING", label: "IN_PERSON_MEETING" },
  { value: "OTHER", label: "OTHER" },
];

const FOLLOWUP_PRIORITY_OPTIONS = [
  { value: "LOW", label: "LOW" },
  { value: "MEDIUM", label: "MEDIUM" },
  { value: "HIGH", label: "HIGH" },
  { value: "CRITICAL", label: "CRITICAL" },
];

const FOLLOWUP_STATUS_OPTIONS = [
  { value: "UPCOMING", label: "UPCOMING" },
  { value: "DUE_TODAY", label: "DUE_TODAY" },
  { value: "OVERDUE", label: "OVERDUE" },
  { value: "DONE", label: "DONE" },
  { value: "CANCELLED", label: "CANCELLED" },
];

const FOLLOWUP_SOURCE_OPTIONS = [
  { value: "lead", label: "Lead Follow-ups" },
  { value: "quotation", label: "Quotation Follow-ups" },
];

const LEAD_TYPE_OPTIONS = [
  { value: "B2C", label: "B2C — Individual" },
  { value: "B2B", label: "B2B — Company / Agent" },
];

const QUOTATION_TYPE_OPTIONS = [
  { value: "B2C", label: "B2C" },
  { value: "B2B", label: "B2B" },
];

const QUOTATION_STATUS_OPTIONS = [
  { value: "DRAFT", label: "DRAFT" },
  { value: "SENT", label: "SENT" },
  { value: "APPROVED", label: "APPROVED" },
  { value: "CANCELLED", label: "CANCELLED" },
];

const PAYMENT_GATEWAY_OPTIONS = [
  { value: "PHONEPE", label: "PHONEPE" },
  { value: "RAZORPAY", label: "RAZORPAY" },
  { value: "CCAVENUE", label: "CCAVENUE" },
  { value: "HBL", label: "HBL" },
  { value: "NABIL_TWEC", label: "NABIL_TWEC" },
  { value: "OFFLINE_NEFT", label: "OFFLINE_NEFT" },
];

export {
  STATUS_OPTIONS,
  SOURCE_OPTIONS,
  LEAD_TYPE_OPTIONS,
  FOLLOWUP_TYPE_OPTIONS,
  FOLLOWUP_PRIORITY_OPTIONS,
  FOLLOWUP_STATUS_OPTIONS,
  FOLLOWUP_SOURCE_OPTIONS,
  QUOTATION_TYPE_OPTIONS,
  QUOTATION_STATUS_OPTIONS,
  PAYMENT_GATEWAY_OPTIONS,
};